/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Kept_InInputs */

const en_us2_draft_kept_in = /** @type {(inputs: Draft_Kept_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You kept it`)
};

const pt_br2_draft_kept_in = /** @type {(inputs: Draft_Kept_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você manteve`)
};

const es_419_draft_kept_in = /** @type {(inputs: Draft_Kept_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo mantuviste`)
};

const pt_pt2_draft_kept_in = /** @type {(inputs: Draft_Kept_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantiveste`)
};

const fr_fr2_draft_kept_in = /** @type {(inputs: Draft_Kept_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu l'as gardé`)
};

const de_de2_draft_kept_in = /** @type {(inputs: Draft_Kept_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast sie behalten`)
};

const it_it2_draft_kept_in = /** @type {(inputs: Draft_Kept_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'hai tenuto`)
};

/**
* | output |
* | --- |
* | "You kept it" |
*
* @param {Draft_Kept_InInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_kept_in = /** @type {((inputs?: Draft_Kept_InInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Kept_InInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_kept_in(inputs)
	if (locale === "es-419") return es_419_draft_kept_in(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_kept_in(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_kept_in(inputs)
	if (locale === "de-DE") return de_de2_draft_kept_in(inputs)
	if (locale === "it-IT") return it_it2_draft_kept_in(inputs)
	return en_us2_draft_kept_in(inputs)
});
export { draft_kept_in as "draft.kept_in" }